import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
  FaChevronLeft,
  FaChevronRight,
  FaQuoteLeft,
} from "react-icons/fa";

const Reviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [reviewsPerView, setReviewsPerView] = useState(3);

  const reviews = [
    {
      id: 1,
      name: "John Martinez",
      location: "Miami, FL",
      rating: 5,
      comment:
        "Absolutely outstanding service! Trans World Shipping delivered our container 3 days ahead of schedule. Their tracking system is top-notch and customer support is available 24/7. Will definitely use them again.",
    },
    {
      id: 2,
      name: "Sarah Johnson",
      location: "Los Angeles, CA",
      rating: 5,
      comment:
        "Best shipping company we've ever worked with. They handled our fragile electronics with extreme care. The customs clearance process was seamless and stress-free.",
    },
    {
      id: 3,
      name: "Michael Chen",
      location: "Vancouver, Canada",
      rating: 4.5,
      comment:
        "Reliable and professional. Our ocean freight arrived exactly when promised. The documentation was perfect and their rates are very competitive. Highly recommended!",
    },
    {
      id: 4,
      name: "Emma Williams",
      location: "London, UK",
      rating: 5,
      comment:
        "Exceptional service from start to finish. The team kept us updated throughout the entire shipping process. Our project cargo arrived in perfect condition.",
    },
    {
      id: 5,
      name: "David Rodriguez",
      location: "Houston, TX",
      rating: 5,
      comment:
        "Trans World has been our logistics partner for 5 years. Never a single issue. Their air freight division is incredibly fast and reliable. Five stars isn't enough!",
    },
    {
      id: 6,
      name: "Lisa Thompson",
      location: "Sydney, Australia",
      rating: 4.5,
      comment:
        "Very impressed with their warehouse and distribution services. They helped us streamline our supply chain and reduce costs significantly.",
    },
    {
      id: 7,
      name: "Robert Kim",
      location: "Seoul, South Korea",
      rating: 5,
      comment:
        "The reefer express service is fantastic. Our temperature-sensitive products arrived perfectly chilled. Professional team from pickup to delivery.",
    },
    {
      id: 8,
      name: "Maria Garcia",
      location: "Mexico City, Mexico",
      rating: 5,
      comment:
        "Incredible attention to detail. They handled our household relocation with care and precision. The movers were courteous and efficient. Thank you Trans World!",
    },
    {
      id: 9,
      name: "James Wilson",
      location: "Chicago, IL",
      rating: 4.5,
      comment:
        "Great communication throughout. Their intermodal solutions saved us time and money. The online tracking portal is user-friendly and accurate.",
    },
    {
      id: 10,
      name: "Patricia Brown",
      location: "Toronto, Canada",
      rating: 5,
      comment:
        "Trans World is simply the best. Their consolidated cargo service helped us save on shipping costs while maintaining fast delivery times. Highly professional team.",
    },
    {
      id: 11,
      name: "Thomas Anderson",
      location: "Berlin, Germany",
      rating: 5,
      comment:
        "Outstanding logistics partner! They handled our complex project cargo with expertise. No delays, no damage, just perfect execution.",
    },
    {
      id: 12,
      name: "Jennifer Lee",
      location: "Singapore",
      rating: 4.5,
      comment:
        "Very reliable ocean freight services. The documentation team made customs clearance a breeze. Will definitely recommend to other importers.",
    },
    {
      id: 13,
      name: "Christopher Taylor",
      location: "Atlanta, GA",
      rating: 5,
      comment:
        "Been using Trans World for 3 years now. Their warehouse distribution network is impressive. Never lost a single package. They truly care about their customers.",
    },
    {
      id: 14,
      name: "Amanda White",
      location: "Auckland, New Zealand",
      rating: 5,
      comment:
        "Excellent air freight service! They rushed our emergency shipment and delivered within 48 hours. The customer service team went above and beyond.",
    },
    {
      id: 15,
      name: "Daniel Moore",
      location: "Dallas, TX",
      rating: 4.5,
      comment:
        "Very satisfied with their logistics solutions. They helped optimize our supply chain and reduce transit times. Great value for money.",
    },
    {
      id: 16,
      name: "Michelle Davis",
      location: "Paris, France",
      rating: 5,
      comment:
        "Trans World made international shipping stress-free. Their team handled everything from pickup to delivery. The tracking updates were frequent and accurate.",
    },
    {
      id: 17,
      name: "Kevin Zhang",
      location: "Shanghai, China",
      rating: 5,
      comment:
        "Best NVO carrier in the industry. Their rates are competitive and service is exceptional. Our consolidated cargo shipments always arrive on time.",
    },
    {
      id: 18,
      name: "Rachel Adams",
      location: "Boston, MA",
      rating: 4.5,
      comment:
        "Great experience with their household removals. They moved our entire home overseas without any issues. The packing team was meticulous and careful.",
    },
    {
      id: 19,
      name: "Brian Miller",
      location: "Amsterdam, Netherlands",
      rating: 5,
      comment:
        "Top-tier logistics provider. Their international trade compliance team ensured all our paperwork was perfect. No customs issues whatsoever. Highly recommended!",
    },
    {
      id: 20,
      name: "Stephanie Clark",
      location: "Seattle, WA",
      rating: 5,
      comment:
        "Trans World Shipping exceeded all expectations. Their project cargo division handled our heavy machinery with expertise. Professional, reliable, and affordable.",
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setReviewsPerView(1);
      } else if (window.innerWidth <= 1024) {
        setReviewsPerView(2);
      } else {
        setReviewsPerView(3);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const nextSlide = () => {
    if (currentIndex + reviewsPerView < reviews.length) {
      setCurrentIndex(currentIndex + 1);
    } else {
      setCurrentIndex(0);
    }
  };

  const prevSlide = () => {
    if (currentIndex - 1 >= 0) {
      setCurrentIndex(currentIndex - 1);
    } else {
      setCurrentIndex(reviews.length - reviewsPerView);
    }
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`star-${i}`} />);
    }

    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half-star" />);
    }

    const emptyStars = 5 - stars.length;
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FaRegStar key={`empty-${i}`} />);
    }

    return stars;
  };

  const visibleReviews = reviews.slice(
    currentIndex,
    currentIndex + reviewsPerView,
  );

  return (
    <TheReviews>
      <div className="reviews-header">
        <h2>What Our Customers Say</h2>
        <p>
          Join thousands of satisfied customers who trust Trans World Shipping
        </p>
        <div className="header-line"></div>
      </div>

      <div className="reviews-container">
        <button className="nav-button prev" onClick={prevSlide}>
          <FaChevronLeft />
        </button>

        <div className="reviews-carousel">
          {visibleReviews.map((review) => (
            <div className="review-card" key={review.id}>
              <FaQuoteLeft className="quote-icon" />
              <div className="stars">{renderStars(review.rating)}</div>
              <p className="review-comment">"{review.comment}"</p>
              <div className="reviewer-info">
                <h4>{review.name}</h4>
                <span>{review.location}</span>
              </div>
            </div>
          ))}
        </div>

        <button className="nav-button next" onClick={nextSlide}>
          <FaChevronRight />
        </button>
      </div>

      <div className="dots-container">
        {Array.from({ length: Math.ceil(reviews.length / reviewsPerView) }).map(
          (_, idx) => (
            <button
              key={idx}
              className={`dot ${Math.floor(currentIndex / reviewsPerView) === idx ? "active" : ""}`}
              onClick={() => setCurrentIndex(idx * reviewsPerView)}
            />
          ),
        )}
      </div>

      <div className="rating-summary">
        <div className="average-rating">
          <span className="rating-number">4.8</span>
          <div className="rating-stars">{renderStars(4.8)}</div>
          <span className="rating-count">Based on 2,500+ reviews</span>
        </div>
      </div>
    </TheReviews>
  );
};

const TheReviews = styled.div`
  width: 100%;
  padding: 4rem 10rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);

  .reviews-header {
    text-align: center;
    margin-bottom: 3rem;

    h2 {
      font-size: 2.5rem;
      color: #0b1e33;
      margin-bottom: 1rem;
      font-weight: 700;
    }

    p {
      font-size: 1.1rem;
      color: #4a5568;
      margin-bottom: 1.5rem;
    }

    .header-line {
      width: 70px;
      height: 3px;
      background: #d4af37;
      margin: 0 auto;
      border-radius: 2px;
    }
  }

  .reviews-container {
    position: relative;
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .reviews-carousel {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    overflow: hidden;
  }

  .review-card {
    background: white;
    padding: 2rem;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    position: relative;
    border: 1px solid rgba(212, 175, 55, 0.1);

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
      border-color: rgba(212, 175, 55, 0.3);
    }
  }

  .quote-icon {
    color: #d4af37;
    font-size: 1.5rem;
    opacity: 0.5;
    margin-bottom: 1rem;
  }

  .stars {
    margin-bottom: 1rem;
    color: #d4af37;
    font-size: 0.9rem;
    display: flex;
    gap: 0.25rem;
  }

  .review-comment {
    color: #2d3748;
    line-height: 1.6;
    margin-bottom: 1.5rem;
    font-size: 0.95rem;
    min-height: 100px;
  }

  .reviewer-info {
    border-top: 1px solid #e2e8f0;
    padding-top: 1rem;

    h4 {
      color: #0b1e33;
      font-weight: 700;
      margin-bottom: 0.25rem;
      font-size: 1rem;
    }

    span {
      color: #718096;
      font-size: 0.85rem;
    }
  }

  .nav-button {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #0b1e33;
    font-size: 1rem;

    &:hover {
      background: #d4af37;
      border-color: #d4af37;
      color: white;
      transform: scale(1.05);
    }
  }

  .dots-container {
    display: flex;
    justify-content: center;
    gap: 0.75rem;
    margin-top: 2rem;
  }

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #cbd5e0;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0;

    &.active {
      background: #d4af37;
      width: 25px;
      border-radius: 5px;
    }

    &:hover {
      background: #d4af37;
    }
  }

  .rating-summary {
    margin-top: 3rem;
    text-align: center;
    padding-top: 2rem;
    border-top: 1px solid #e2e8f0;
  }

  .average-rating {
    display: inline-flex;
    align-items: center;
    gap: 1rem;
    background: white;
    padding: 1rem 2rem;
    border-radius: 50px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .rating-number {
      font-size: 2rem;
      font-weight: 800;
      color: #0b1e33;
    }

    .rating-stars {
      color: #d4af37;
      display: flex;
      gap: 0.25rem;
    }

    .rating-count {
      color: #718096;
      font-size: 0.9rem;
    }
  }

  @media screen and (max-width: 1366px) {
    padding: 4rem 6rem;

    .reviews-carousel {
      gap: 1.5rem;
    }
  }

  @media screen and (max-width: 1200px) {
    padding: 3.5rem 4rem;
  }

  @media screen and (max-width: 1024px) {
    .reviews-carousel {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media screen and (max-width: 900px) {
    padding: 3rem 3rem;

    .reviews-header {
      h2 {
        font-size: 2rem;
      }
    }

    .review-card {
      padding: 1.5rem;
    }

    .review-comment {
      font-size: 0.9rem;
      min-height: 120px;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 3rem 2rem;

    .reviews-carousel {
      grid-template-columns: 1fr;
    }

    .review-comment {
      min-height: auto;
    }

    .average-rating {
      flex-direction: column;
      gap: 0.5rem;
      padding: 1rem;
    }
  }

  @media screen and (max-width: 600px) {
    padding: 2rem 1.5rem;

    .reviews-header {
      h2 {
        font-size: 1.5rem;
      }

      p {
        font-size: 0.9rem;
      }
    }

    .nav-button {
      width: 32px;
      height: 32px;
      font-size: 0.8rem;
    }

    .review-card {
      padding: 1rem;
    }
  }

  @media screen and (max-width: 420px) {
    padding: 2rem 1rem;

    .nav-button {
      width: 28px;
      height: 28px;
    }
  }

  @media screen and (max-width: 350px) {
    .reviews-container {
      gap: 0.5rem;
    }

    .nav-button {
      width: 25px;
      height: 25px;
    }
  }
`;

export default Reviews;
